import React from 'react';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';

import GalleryCommunityCard from '../communityCard/gallery';

function RelatedCommunities(props) {
  const {
    communities = [],
    headerText = communities.length > 1 ? 'Meet the Communities' : 'Meet the Community',
    pageId,
  } = props;

  const filteredCommunities = communities.filter((c) => c);
  return (
    <>
      <Typography variant='subtitle1' fontWeight={500} sx={{ mb: 1.25 }}>
        {headerText}
      </Typography>
      <Grid container spacing={2}>
        {filteredCommunities.map((community, i) => (
          <Grid key={community._id} item xs={12} md={12 / filteredCommunities.length}>
            <GalleryCommunityCard
              community={community}
              highRes={filteredCommunities.length === 1}
              pageId={pageId}
              placementId={`related-communities-${i}`}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
}

export default RelatedCommunities;
